import Hotkeys from './hotkeys'
import messageApi from './components/message-api'
import { getRootAppWindow } from 'meta/utils/getRootAppWindow'

class HKClient {
    constructor(win) {
        this.win = win || window
        this.hk = Hotkeys(this.win)
        this.hotkeys = {}
        this.frameKeyBindings = {}
        let self = this

        messageApi.on('hotkeys.updateClient', ({data: {frameKeyBindings}}) => {
            self.updateFrameKeyBindings(frameKeyBindings)
        })

        messageApi.on('hotkeys.trigger', ({data: {key}}) => {
            try {
                self.hk.trigger(key)
            } catch (error) {
                console.error(error)
            }
        })

        messageApi.on('hotkeys.resetClient', ({source: {name}}) => {
            self.hotkeys = {}
            self.rebind()
        })

        messageApi.on('hotkeys.unbindClient', ({data: {key}, source: {name}}) => {
            delete self.hotkeys[key]
            self.rebind()
        })

        self.init()
    }

    postTriggerMessage(key, frameName) {
        const rootWindow = getRootAppWindow(this.win);
        let frame = rootWindow.frames[frameName.replace("content_tab", "")];
        if (!frame) {
          const activeFrame = rootWindow.document.querySelector(
            'iframe[data-active="true"]'
          );
          frame = activeFrame.contentWindow.frames[frameName];
        }
        messageApi.send(frame, "hotkeys.trigger", { key });
      }

    updateFrameKeyBindings(frameKeyBindings) {
        this.frameKeyBindings = frameKeyBindings

        this.rebind()
    }

    rebind() {
        this.hk.reset()
        for (const key in this.frameKeyBindings) {
            const value = this.frameKeyBindings[key]
            const {frameName, triggerWhileInTextField} = value
            if(triggerWhileInTextField) {
                this.hk.bindGlobal(key, () => this.postTriggerMessage(key, frameName))
            }
            else {
                this.hk.bind(key, () => this.postTriggerMessage(key, frameName))
            }
        }

        for (const key in this.hotkeys) {
            const value = this.hotkeys[key]
            const {callback, triggerWhileInTextField} = value
            if(triggerWhileInTextField) {
                this.hk.bindGlobal(key, callback)
            }
            else {
                this.hk.bind(key, callback)
            }
        }
    }

    bind(keyMap, forAllFrames = true, triggerWhileInTextField = false) {
        if(triggerWhileInTextField) {
            this.hk.bindGlobal(keyMap)
        }
        else {
            this.hk.bind(keyMap)
        }

        for (const key in keyMap) {
            if (forAllFrames) messageApi.send(getRootAppWindow(this.win), 'hotkeys.bind', {key, triggerWhileInTextField})
            this.hotkeys[key] = {callback: keyMap[key], triggerWhileInTextField}
        }

        return this
    }

    bindHere(keyMap, triggerWhileInTextField = false) {
        this.bind(keyMap, false, triggerWhileInTextField)
    }

    unbind(key) {
        this.hk.unbind(key)
        delete this.hotkeys[key]

        messageApi.send(getRootAppWindow(this.win), 'hotkeys.unbind', {key})

        return this
    }

    reset() {
        this.hk.reset()
        this.hotkeys = {}

        messageApi.send(getRootAppWindow(this.win), 'hotkeys.reset', {})

        return this
    }

    init() {
        // Send init
        messageApi.send(getRootAppWindow(this.win), 'hotkeys.init').then(({data}) => {
            this.updateFrameKeyBindings(data)
        })
    }
}

export default HKClient
